<template>
    <div>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-container v-if="!loading" my-2>
            <form @submit.prevent="update_item_badges" autocomplete="off">
                <v-layout row wrap>

                    <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="text" v-model="item_badges.item_badge_name"
                            :label="$store.getters.lang.data.item_badge_name" outlined class="mx-1" filled required>
                        </v-text-field>
                    </v-flex>



                    <!-- <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="text" v-model="item_badges.item_badge_color"
                            :label="$store.getters.lang.data.item_badge_color" outlined class="mx-1" filled required>
                        </v-text-field>
                    </v-flex> -->



                    <!-- <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="text" v-model="item_badges.item_badge_svg"
                            :label="$store.getters.lang.data.item_badge_svg" outlined class="mx-1" filled required>
                        </v-text-field>
                    </v-flex> -->




                    <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-select class="mx-1" clearable rounded filled :items="items" v-model="item_badges.item_id" outlined
                            item-text="item_name" item-value="item_id" :return-object="false"
                            :label="$store.getters.lang.data.item_name">
                        </v-select>
                    </v-flex>

                    <v-flex xs12 lg2 xl2 md2 sm4>
                        <v-btn color="primary" rounded class="mx-1" x-large type="submit">
                            {{$store.getters.lang.data.update_btn}}</v-btn>
                    </v-flex>
                </v-layout>
            </form>
        </v-container>

        <v-snackbar v-model="snackbar.value" :color="snackbar.color">
            {{snackbar.text}}
        </v-snackbar>
    </div>
</template>

<script>
    import controller from './../../controller/item_badges'
    export default {
        data() {
            return {
                item_badges: {},
                id: '',
                loading: true,
                snackbar: {
                    value: false,
                    text: '',
                    color: ''
                },

            }
        },
        computed: {

            items() {
                return this.$store.getters.items
            },


        },
        methods: {
            get_item_badges() {
                this.loading = true
                controller.getOne(this.id).then(r => {
                    this.item_badges = r.data.row
                    this.loading = false
                }).catch(e => {
                    console.log(e);
                })
            },
            update_item_badges() {
                controller.update_item_badges(this.item_badges).then(r => {
                    if (r.data) {
                        this.snackbar = {
                            value: true,
                            text: 'Updated',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Not Updated',
                            color: 'error'
                        }
                    }
                })
            },

        },
        mounted() {
            this.id = this.$route.params.id
            this.get_item_badges()
        },
    }
</script>